import loadable from '@loadable/component';

import { useFlag } from '@/features/unleash';

const MyPortfoliosLanding = loadable(() => import('./components/Landing'));
const DeprecatedPortfoliosContainer = loadable(
  () => import('@/containers/DeprecatedPortfoliosContainer')
);

export const MyPortfoliosSwitcher = () => {
  const portfolioHubFlag = useFlag({
    name: 'mono-portfolio-hub',
  });

  const canAccessPortfolioHub =
    portfolioHubFlag.flagsReady && portfolioHubFlag.enabled;

  return canAccessPortfolioHub ? (
    <MyPortfoliosLanding />
  ) : (
    <DeprecatedPortfoliosContainer />
  );
};
